var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"page-loading",rawName:"v-page-loading",value:(_vm.app.loading),expression:"app.loading"}],attrs:{"id":"app"}},[_c('sidebar'),_c('config-panel'),_c('preview')],1)}
var staticRenderFns = []

export { render, staticRenderFns }